import { Route } from 'config/routes';

export const navEventMap = {
  [Route.MyHomes]: 'addresses',
  [Route.Shortlist]: 'shortlist',
  [Route.Search]: 'search',
};
